export const constants = {
    contentTypeJSON: 'application/json',
}

export const BASE_URL: string | undefined = undefined

export const DEFAULT_VIMEO_SETTINGS = {
    //privacy: { view: 'unlisted', download: false },
}
